<mat-card>
  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #8cd6b7;">
    <div class="flex flex-row rounded-lg w-full" style="align-items: center;">
      <div class="flex flex-col w-full" style="padding-left: 20px;">
        <h4><span class="glyphicon glyphicon-file"></span>Enter New Business</h4>
      </div>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div class="flex flex-col items-center w-full">
      <!-- <div *ngIf="!showList" class="flex flex-col items-center w-full scrollable-div"> -->
        <div class="flex flex-col rounded-lg w-11/12" style="padding: 20px; overflow-x:auto;">
        <a (click)="showExemptBusinesses()" title="Check list of exempt businesses">Check list of exempt businesses</a>

        <hr style="border: 1px solid gray;">
        <br />
        <form [formGroup]="businessForm">
          <div class="flex flex-col rounded-lg w-full">
            <div class="flex flex-row w-full">

              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>Business Name</mat-label>
                  <input matInput formControlName="businessName" placeholder="Enter business name here">
                </mat-form-field>
              </div>
              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>Contact Name</mat-label>
                  <input matInput formControlName="contactName" placeholder="Enter contact name here">
                </mat-form-field>
              </div>

            </div>

            <div class="flex flex-row w-full">

              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>Type Of Business</mat-label>
                  <mat-select formControlName="businessType">
                    <mat-option *ngFor="let list of typeOfBusinessList" [value]="list.value">
                      {{list.text}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>Contact Title</mat-label>
                  <input matInput formControlName="contactTitle" placeholder="Enter contact title here">
                </mat-form-field>
              </div>

            </div>

            <div class="flex flex-row w-full">

              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>Address</mat-label>
                  <input matInput formControlName="businessAddress1" placeholder="Enter business address here">
                </mat-form-field>
              </div>
              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>Contact Email</mat-label>
                  <input matInput formControlName="contactEmail" placeholder="Enter contact email here">
                </mat-form-field>
              </div>

            </div>

            <div class="flex flex-row w-full">

              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>Address 2</mat-label>
                  <input matInput formControlName="businessAddress2" placeholder="Enter business address 2 here">
                </mat-form-field>
              </div>
              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>Business Owner</mat-label>
                  <input matInput formControlName="businessOwner" placeholder="Enter business owner here">
                </mat-form-field>
              </div>

            </div>

            <div class="flex flex-row w-full">

              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>City</mat-label>
                  <input matInput formControlName="businessCity" placeholder="Enter business city here">
                </mat-form-field>
              </div>
              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>State</mat-label>
                  <input matInput formControlName="stateId" placeholder="Enter state here">
                </mat-form-field>
              </div>

            </div>

            <div class="flex flex-row w-full">

              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>Zip Code</mat-label>
                  <input matInput formControlName="businessZip" placeholder="Enter business zip here">
                </mat-form-field>
              </div>
              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>County</mat-label>
                  <mat-select formControlName="countyId">
                    <mat-option *ngFor="let list of countyList" [value]="list.value">
                      {{list.text}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

            </div>

            <div class="flex flex-row w-full">

              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>Business Phone</mat-label>
                  <input matInput formControlName="businessPhone" placeholder="Enter business phone here">
                </mat-form-field>
              </div>
              <div class="w-1/2">
                <mat-form-field>
                  <mat-label>Extension</mat-label>
                  <input matInput formControlName="businessPhoneExt" placeholder="Enter extension here">
                </mat-form-field>
              </div>

            </div>

            <div class="flex flex-row" style="align-items: flex-start;">
              <div style="padding-right: 20px;">
                <button mat-raised-button (click)="save()" class="m-8 container" style="background: #7ABDF3;">
                  Save
                </button>
              </div>
              <div style="padding-right: 20px;">
                <button mat-raised-button (click)="return()" class="m-8 container">
                  Return
                </button>
              </div>
            </div>

          </div>
        </form>

      </div>
      <br />
      <hr style="border: 1px solid gray;">
    </div>
  </mat-card-content>
</mat-card>

